import { apiEndpoint } from "../urls";

const absoluteUrlPattern = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;

export const isTruthyFlag = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

export const isAbsoluteUrl = (url) =>
  typeof url === "string" && absoluteUrlPattern.test(url);

export const joinUrl = (baseUrl, path) => {
  if (!path) return "";
  if (isAbsoluteUrl(path)) return path;

  const base = String(baseUrl || "").replace(/\/+$/, "");
  const suffix = String(path).replace(/^\/+/, "");
  return `${base}/${suffix}`;
};

export const getEsignDocumentUrl = (path) =>
  joinUrl(apiEndpoint.esignBaseUri, path);

export const getSignedFinalPdfUrl = (doc, username) => {
  if (isAbsoluteUrl(doc?.pdf_path)) {
    return doc.pdf_path;
  }

  if (!username || !doc?.uuid || !doc?.mobile) {
    return "";
  }

  return getEsignDocumentUrl(
    `PDFs/${username}/${doc.uuid}/${doc.mobile}/pdfForEsign_signedFinal.pdf`
  );
};

export const isTemplatePdfUploadedToS3 = (documentData) =>
  isTruthyFlag(documentData?.is_template_pdf_uploaded_to_s3) ||
  isTruthyFlag(documentData?.is_uploaded_to_s3);

export const getPdfEditorDocumentUrl = (documentData) => {
  const documentUrl = documentData?.document_url;
  if (!documentUrl) return "";

  if (isTemplatePdfUploadedToS3(documentData) || isAbsoluteUrl(documentUrl)) {
    return documentUrl;
  }

  return joinUrl(apiEndpoint.pdfBaseUri, documentUrl);
};
